














































import { Component, Vue, Emit } from 'vue-property-decorator';
import axios from 'axios';
import { vxm } from '../../../store.vuex';

import SectionTitle from '@/components/Commons/SectionTitle.vue';
import ChatMenu from '../leftframe/ChatMenu.vue';
import ChatFrame from '../rightframe/ChatFrame.vue';

import { REFERRAL_TYPE } from './../ChatConstants';

@Component({
  name: 'ChatLanding',
  components: {
    SectionTitle,
    ChatMenu,
    ChatFrame,
  },
})
export default class ChatLanding extends Vue {
  private referralStats = vxm.referrals.getReferralStats;
  private promoteReferral = vxm.referrals.getReferralSuccess;
  private sorting: boolean = true;
  private searchText: string = '';
  private arch: number = 0;
  private isAdmin: boolean = false;
  private userId: number = vxm.users.myUserProfile.userId;
  private companyCode: string = vxm.users.getCompanyCode;
  private pageNumber: number = 1;
  private pageSize: number = 10;
  private unreadChats: boolean = false;
  private chatMenuData: object = {};
  private chattingData: object = {};
  private isChatDataPresent: boolean = false;
  private isCandidateConversationAvailable: boolean = false;
  private isActive:boolean = true;
  private chatFilterType: string = 'ACTIVE';

  // private referralSearch = this.lodash.debounce((searchText) => {
  //   vxm.referrals.fetchReferralStats({
  //     searchString: searchText,
  //     ascending: this.sorting,
  //   });
  // }, 500);

  private searchClaimableConversations = this.lodash.debounce(
    (arch, isAdmin, userId, companyCode, pageNumber, pageSize, unreadChats) => {
      vxm.jobs.searchClaimableConversations({
        archieve: arch,
        isAdmin: isAdmin,
        userId: userId,
        companyCode: companyCode,
        pageNumber: pageNumber,
        pageSize: pageSize,
        unreadChats: unreadChats,
      });
    },
    500,
  );

  userChattingData(val) {
    console.log('Emited value: ', val);
    this.$emit('user-chating-data', val);
    this.chattingData = val;
  }
  candidateConversation(status) {
    console.log('Success Status:', status);
    this.$emit('candidate-conversation', status);
    this.isCandidateConversationAvailable = status;
  }
  chatMenuResponseData(val) {
    this.$emit('chat-menu-response-data', val);
    this.chatMenuData = val;
  }
  reloadChatingData(status) {
    console.log('Need to reload: ', status);
    if (status) {
      if(status==10){
        console.log("updating false");
        this.isActive = false;
        this.unreadChats = false;
        this.chatFilterType = 'ARCHIVED';
      }else if(status==20){
        console.log("updating true");
        this.isActive = true;
        this.unreadChats = false;
        this.chatFilterType = 'ACTIVE';
      } else {
        console.log("updating active true and unread as true")
        this.isActive = true;
        this.unreadChats = true;
        this.chatFilterType = 'UNREAD';
      }
      this.loadCandidateChatData();
    }
  }

  async loadCandidateChatData() {
    try {
      let menuData = await vxm.jobs.searchClaimableConversations({
        archieve: this.isActive?0:1,
        isAdmin: false,
        userId: this.userId,
        companyCode: this.companyCode,
        pageNumber: 1,
        pageSize: 100,
        unreadChats: this.unreadChats,
      });
      this.chatMenuData = menuData;
      if(this.isActive && menuData.activeChatCount > 0){
        this.isChatDataPresent = true;
      }
      else if(!this.isActive && menuData.archiveChatCount > 0){
        this.isChatDataPresent = true;
      } else {
        this.isChatDataPresent = false;
      }
      try {
        let converstsnGUID:String = '';
        if (
          menuData.activeConversations &&
          menuData.activeConversations.length > 0
        ) {
          if(vxm.jobs.ActiveConversationGUID!==null && vxm.jobs.ActiveConversationGUID!==''){
            converstsnGUID = vxm.jobs.ActiveConversationGUID;
          }else{
            converstsnGUID = menuData.activeConversations[0].conversationGUID;
          }
          let candidateChatData = await vxm.jobs.fetchConversation({
            isAdmin: false,
            conversationGUID: converstsnGUID
          });
          this.chattingData = candidateChatData;
          this.isCandidateConversationAvailable = true;
        }
        else if (
          menuData.archiveConversations &&
          menuData.archiveConversations.length > 0
        ) {
          if(vxm.jobs.ActiveConversationGUID!==null && vxm.jobs.ActiveConversationGUID!==''){
            converstsnGUID = vxm.jobs.ActiveConversationGUID;
          }else{
            converstsnGUID = menuData.archiveConversations[0].conversationGUID;
          }
          let candidateChatData = await vxm.jobs.fetchConversation({
            isAdmin: false,
            conversationGUID: converstsnGUID
          });
          this.chattingData = candidateChatData;
          this.isCandidateConversationAvailable = true;
        } else {
          this.isCandidateConversationAvailable = false;
        }
      } catch (exception) {
        let response = {
          success: false,
        };
        this.chattingData = response;
        this.isCandidateConversationAvailable = false;
      }
    } catch (exc) {
      this.chatMenuData = exc;
      this.isChatDataPresent = false;
      this.isCandidateConversationAvailable = false;
      let conversationResponse = {
        success: false,
      };
      this.chattingData = conversationResponse;
    }
  }

  async mounted() {
    this.loadCandidateChatData();
  }
}
